import { html, TemplateResult } from 'lit'
import { AttributeValue } from 'components/discovery/shared/search/typing/filter-attributes.js'
import { ImageDisplayConfig } from 'components/discovery/filter-wizard/typing/config.js'
import './name.js'
import './image.js'

export type DisplayType = (attributeValues: AttributeValue[]) => TemplateResult

const createDisplayTypeMap = (imageConfig?: ImageDisplayConfig): Record<string, DisplayType> => ({
  default: (attributeValues) => html`
    <cse-selectable-group multiple inline>
      ${attributeValues.map(
        av => html`<csc-attribute-value-name .attributeValue=${av}></csc-attribute-value-name>`
      )}
    </cse-selectable-group>
  `,
  image: (attributeValues) => html`
    <cse-selectable-group multiple inline>
      ${attributeValues.map(
        av => html`<csc-attribute-value-image .attributeValue=${av} .imageConfig=${imageConfig}></csc-attribute-value-image>`
      )}
    </cse-selectable-group>
  `,
})

export const getDisplayTypeElement = (displayType: string | null, imageConfig?: ImageDisplayConfig): DisplayType => {
  const displayTypeMap = createDisplayTypeMap(imageConfig)
  const displayTypeElement = displayTypeMap[displayType ?? 'default']
  if (displayTypeElement === undefined) { throw 'dikke error in getDisplayTypeElement' }

  return displayTypeElement
}
